// extracted by mini-css-extract-plugin
export default {"customTabBar":"customTabs_customTabBar__KddOc"};